import { z } from 'zod';

import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const FundingSourceV2Values = [
  'employment_income',
  'inheritance_or_family',
  'savings',
  'investments_or_trading',
  'real_estate',
  'third_party_donation_or_gambling',
] as const;

export const ZodFundingSourceV2 = z.enum(FundingSourceV2Values);

export const ZodFundingSource = z.enum([
  'investments',
  'inheritance',
  'business_income',
  'family',
  'self_employment_income',
  'pension',
  ...FundingSourceV2Values,
]);

export type FundingSource = z.infer<typeof ZodFundingSource>;
export type FundingSourceV2 = z.infer<typeof ZodFundingSourceV2>;

export const UNSUPPORTED_FUNDING_SOURCES: Extract<
  FundingSource,
  'investments' | 'inheritance' | 'family'
>[] = ['investments', 'inheritance', 'family'];

export const ZodFunctionSourceOption = ZodFundingSource.exclude(UNSUPPORTED_FUNDING_SOURCES);
export type FundingSourceOption = z.infer<typeof ZodFunctionSourceOption>;

export const B2BFundingSourceValues = [
  'donation',
  'inheritance',
  'life_insurance_or_capitalization_contract',
  'employee_savings_withdrawal_or_income',
  'real_estate_or_movable_property_sale',
  'sale_of_securities',
  'transfer_of_assets_or_clientele',
  'dividends',
  'other',
] as const;

export const ZodB2BFundingSource = z.enum(B2BFundingSourceValues);
export type B2BFundingSource = z.infer<typeof ZodB2BFundingSource>;

export const B2BFundingSocioProfessionalCategories = [
  'farmers',
  'artisans',
  'retailers_and_similar_businesses',
  'business_owners_with_10_or_more_employees',
  'professional_and_related_occupations',
  'civil_service_executives_intellectual_and_artistic_professions',
  'corporate_executives',
  'intermediate_occupations_in_education_health_care_the_civil_service_and_related_fields',
  'intermediate_administrative_and_business_occupations_in_businesses',
  'technicians',
  'foremen_supervisors',
  'civil_servants',
  'corporate_administrative_staff',
  'sales_associates',
  'staff_in_direct_to_consumer_services',
  'skilled_workers',
  'unskilled_workers',
  'farmworkers',
  'former_artisans_merchants_and_business_owners',
  'unemployed_people_who_have_never_worked',
  'miscellaneous_non_working_individuals_other_than_retirees',
  'other',
] as const;
export const ZodB2BFundingSocioProfessionalCategory = z.enum(B2BFundingSocioProfessionalCategories);
export type B2BFundingSocioProfessionalCategory = z.infer<
  typeof ZodB2BFundingSocioProfessionalCategory
>;

export const ZodB2BFundingSocioProfessionalCategoryComment = ZodTrimmedString.min(3)
  .max(100)
  .regex(/^[0-9()'\p{Letter} -]+$/u);
export type B2BFundingSocioProfessionalCategoryComment = z.infer<
  typeof ZodB2BFundingSocioProfessionalCategoryComment
>;
